import NameSyncStatus from "../../components/devices/NameSyncStatus";
import React from "react";
import { format } from "date-fns";

import ModalManager from "../../components/common/modal/ModalManager";
import SelectInput from "../../components/common/inputs/selectInput";
import TextInput from "../../components/common/inputs/textInput";
import { formatDistanceStrict } from "date-fns";
import { Link } from "react-router-dom";
import NotificationManager from "../../utils/notificationManager";
import Pagination from "../../components/common/pagination";
// import Loading from '../../components/common/loading';
import ReactPaginate from "react-paginate";
import OutletCard from "../../components/devices/OutletCard";
import {
  AppCard,
  AppPage,
  AppPageHeader,
  AppToolbar,
  AppToolbarField,
} from "../../components/common/appShell";

const columnWidths = [
  1, //0 checkbox
  1, //1 outlet#
  7, //2 outlet name
  6, //3 PDU
  2, //4 outlet state
  5, //5 outlet current
  2, //6 outlet power
  3, //7 outlet voltage
  8, //8 operation
  2, //9 updated
  1, //10 refresh
];

class DeviceOutlets extends React.Component {
  state = {

    search: "",
    loadingOutlets: [],

    chartzViewType: "outletSwitchingView", // outletSwitchingView
    dark: typeof document !== "undefined" && document.body.classList.contains("dark-mode"),
  };
  applyFilters = () => {
    this.setState({
      currentFilter: this.state.search,
    });
  };

  applySearch = () => {
    this.fetchPage()
  }

  componentDidMount() {
    this.props.fetchResourcePaginate("outlets", undefined, {
      page: 1,
      ...this.props.queryParams
    }, true)
    if (typeof document !== "undefined") {
      this.darkObserver = new MutationObserver(() => {
        const isDark = document.body.classList.contains("dark-mode");
        this.setState((prev) => (prev.dark === isDark ? null : { dark: isDark }));
      });
      this.darkObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    }
  }

  componentWillUnmount() {
    this.darkObserver && this.darkObserver.disconnect();
  }
  fetchPage = () => {
    const {
      search
    } = this.state;

    const passedQueryParams = this.props.queryParams || {};

    const queryParams = {
      page: 1,
      search,
      ...passedQueryParams
    }
    this.props.fetchResourcePaginate("outlets", undefined, queryParams, true)
  }

  editOutletName = (outlet) => {
    ModalManager.confirm(
      "",
      `Outlet ${outlet.outlet_id}`,
      "",
      (submitted, close) => {
        if (submitted) {
          close();
        }
      },
      ({ close }) => (
        <EditOutletForm
          updateOutlet={this.updateOutlet}
          outlet={outlet}
          close={close}
        />
      ),
      true,
      true
    );
  };
  refreshOutlet = outletId =>  {
    this.setState(prev => ({
      loadingOutlets: [...prev.loadingOutlets, outletId],
    }));
    this.props.getOutletItemAndData(outletId, (err, data) => {
      this.setState(prev => ({
        loadingOutlets: prev.loadingOutlets.filter(id => id !== outletId),
      }));
      if (err) {
        NotificationManager.alert("Error fetching outlet data", "Error");
        console.log(err);
      } else {
      }
    })
  }
  updateOutlet = (outletId, status, cb = () => {}, idField, noNotification) => {
    this.setState(prev => ({
      loadingOutlets: [...prev.loadingOutlets, outletId],
    }));
    this.props.updateOutletItem(
      outletId,
      status,
      (err, data) => {
        this.setState(prev => ({
          loadingOutlets: prev.loadingOutlets.filter(id => id !== outletId),
        }));
        cb(err, data)
        if (data) {
          if (status.state === "REBOOT") {
            console.log(data)
            const rebootTime = data.rebootTime
            // make a fetch call to re-get the outlet or device one second after the reboot time, if no reboot time default to 5 seconds
            const fetchTime = rebootTime ? rebootTime + 1 : 5; // seconds
            setTimeout(() => {
              // this.props.fetchResource("outlets");
              // this.props.fetchResource("devices");
              this.refreshOutlet(
                outletId,
                () => {},
              );
            }, fetchTime * 1000); // setTimeout accepts ms
          }
        }
      }
    )
  };
  render() {

    const pageNum = this.props.resources.outletsMeta?.currentPage || 1
    const currentOutlets = this.props.resources.outletsPages.find(pag => pag.page == pageNum)?.outlets || [];
    const noOutletsWithPowerMeasurements = currentOutlets.filter(o => o.currentRms === undefined || o.currentRms === null).length === currentOutlets.length;
    // const noOutletsWithPowerMeasurements = false;
    //  currentOutlets ? currentOutlets.filter(o => o.currentRms === undefined || o.currentRms === null).length === currentOutlets.outlets.length : false
    const role = this.props.user.role;
    const outletsSwitchesAllowed = (() => {
      if (!role) {
        return true;
      } else {
        if (role.switchAllOutletsAllowed) {
          return true;
        } else {
          return false;
        }
      }
    })();


    return (
      <AppPage>
        <AppPageHeader
          title="Outlets"
          description="Search outlets, review live state and power readings, and manage supported outlet actions."
        />
        <AppCard
          variant="hybrid-list"
          // title="Outlet inventory"
          // description="Review outlet state, live readings, and supported operations."
        >
        <AppToolbar>
          <AppToolbarField label="Search outlets">
            <div className="app-toolbar__search">
              <input
                type="text"
                placeholder="Search by outlet name or serial number"
                value={this.state.search}
                onChange={(e) => {
                  this.setState({ search: e.target.value });
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    this.applySearch();
                  }
                }}
              />
              <span
                className="search-icon-button"
                onClick={() => {
                  this.applyFilters();
                }}
              >
                <i className="material-icons">search</i>
              </span>
            </div>
          </AppToolbarField>
        </AppToolbar>
        <div
          style={{
            // border: "solid red 1px",
            overflowX: "auto",
            // maxHeight: "80vh",
          }}
        >
          {/* {!this.props.resources.outletsLoading && outlets.length === 0 && (
            <React.Fragment>
              <div className="grid-row-wrapper">
                <div className="grid-row">
                  <div
                    style={{
                      paddingLeft: "50px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <div>No Outlets Found</div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "40px",
                }}
              >
                <span className="button">
                  <a
                    href="https://synaccess.readme.io/reference/connect-a-synlink-pdu"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "white" }}
                  >
                    Learn how to connect a SynLink PDU
                  </a>
                </span>
              </div>
            </React.Fragment>
          )} */}
          <PaginatedList
            resourceName="outlets"
            pages={this.props.resources.outletsPages}
            resetPages={() => this.props.resetResourcePages("outlets")}
            pageLoading={this.props.resources.outletsPageLoading}
            fetchResourcePaginate={this.props.fetchResourcePaginate}
            totalItemCount={this.props.resources.outletsMeta.totalCount || undefined}
            hideSearch={true}
            showSummary
            itemLabel="outlets"
            queryParams={{
              search: this.state.search,
              ...this.props.queryParams,
            }}
            resetKey={this.props.resources.outletsPaginationResetKey}
            LoadingProp={() => (
              <div>
                {[null, null, null, null].map((item, index) => {
                  return (
                    <div className="grid-row-wrapper" key={index}>
                      <div className="grid-row">
                        <div style={{ flex: columnWidths[0] }}></div>
                        <div style={{ flex: columnWidths[1] }}>
                          <div className="skeleton-blank" />
                        </div>
                        <div style={{ flex: columnWidths[2] }}>
                          <div className="skeleton-blank" />
                        </div>
                        <div style={{ flex: columnWidths[3] }}>
                          <div className="skeleton-blank" />
                        </div>
                        <div style={{ flex: columnWidths[4] }}>
                          <div className="skeleton-blank" />
                        </div>
                        <div style={{ flex: columnWidths[10] }}></div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            parentProps={{
              ...this.props,
              updateOutlet: this.updateOutlet,
              outletsSwitchesAllowed,
              noOutletsWithPowerMeasurements,
              editOutletName: this.editOutletName,
              getOutletItemAndData: this.refreshOutlet,
              loadingOutlets: this.state.loadingOutlets,
              dark: this.state.dark,
            }}
            ItemRenderer={OutletTableRow}
            renderHeader={() => (
              <>
                <div
                  className="grid-row header hide-for-small-only"
                  style={{ position: "sticky" }}
                >
                  <div style={{ flex: columnWidths[1] }}>Outlet #</div>
                  <div style={{ flex: columnWidths[2] }}>Outlet Name</div>
                  <div style={{ flex: columnWidths[3] }}>PDU</div>
                  <div style={{ flex: columnWidths[4] }}>State</div>
                  {!noOutletsWithPowerMeasurements && (
                    <>
                      <div style={{ flex: columnWidths[5] }}>Current RMS</div>
                      <div style={{ flex: columnWidths[6] }}>Power</div>
                      <div style={{ flex: columnWidths[7] }}>Voltage</div>
                    </>
                  )}
                  {outletsSwitchesAllowed && (
                    <div style={{ flex: columnWidths[8] }}>Operation</div>
                  )}
                  {/* <div style={{ flex: columnWidths[9] }}>Last Updated</div> */}
                  <div style={{ flex: columnWidths[10] }}></div>
                </div>

                <div className="show-for-small-only outlet-card__list-header">
                  Manage Outlets
                </div>

                {this.props.resources.outletsLoading &&
                  this.props.resources.outlets.length === 0 && (
                    <LoadingSection columnWidths={columnWidths} />
                  )}
              </>
            )}
          />
        </div>
        </AppCard>
      </AppPage>
    );
  }
}

const DataValue = ({ value, unit }) => {

  return (
    <span style={{ display: "flex", alignItems: "flex-end" }}>
      <span
        style={{
          fontWeight: "600",
          fontSize: "105%",
        }}
      >
        {(value || 0).toFixed(2)}
      </span>
      <span
        style={{
          fontSize: "80%",
          paddingLeft: "4px",
          paddingBottom: "1px",
        }}
      >
        {unit}
      </span>
    </span>
  );
};
function getColor(value, opacity = 1) {
  //value from 0 to 1
  return value > 1
    ? "#9d0002" //red
    : value > 0.75
    ? "#b87000" //orange
    : value > 0.5
    ? "#CC9900" //yellow
    : value > 0.25
    ? "#7c9d00" // yellow green
    : "green";
}

const LoadingSection = ({ columnWidths }) => {
  return (
    <div style={{}}>
      {[null, null, null, null].map((item, index) => {
        return (
          <div className="grid-row-wrapper" key={index}>
            <div className="grid-row">
              <div style={{ flex: columnWidths[0] }}></div>
              <div style={{ flex: columnWidths[1] }}>
                <div className="skeleton-blank" />
              </div>
              <div style={{ flex: columnWidths[2] }}>
                <div className="skeleton-blank" />{" "}
              </div>
              <div style={{ flex: columnWidths[3] }}>
                <div className="skeleton-blank" />{" "}
              </div>
              <div style={{ flex: columnWidths[4] }}>
                <div className="skeleton-blank" />
              </div>
              <div style={{ flex: columnWidths[5] }}>
                <div className="skeleton-blank" />
              </div>
              <div style={{ flex: columnWidths[6] }}>
                <div className="skeleton-blank" />{" "}
              </div>
              <div style={{ flex: columnWidths[7] }}>
                <div className="skeleton-blank" />
              </div>
              {/* <div style={{ flex: columnWidths[8] }}>
                <div className="skeleton-blank" />
              </div> */}
              {/* <div style={{ flex: columnWidths[9] }}>
                <div className="skeleton-blank" />{" "}
              </div> */}
            </div>
          </div>
        );
      })}
    </div>
  );
};
class OutletTableRow extends React.Component {
  confirmOutletAction = ({ outlet, nextState, actionLabel, updateOutlet }) => {
    const outletId = outlet?.outlet_id;
    if (!outletId || !updateOutlet) return;

    const outletNumber = outlet.pduLabeledOutletNum || outletId;
    const normalizedAction =
      nextState === "REBOOT" ? "power cycle" : actionLabel.toLowerCase();

    ModalManager.confirm(
      `Are you sure you want to ${normalizedAction} Outlet ${outletNumber}?`,
      "Are you sure?",
      actionLabel,
      (submitted, close) => {
        if (!submitted) {
          return;
        }

        if (typeof close === "function") {
          close();
        }

        updateOutlet(outletId, { state: nextState });
      }
    );
  };

  renderStateContent = ({ outlet, isLoading }) => {
    if (isLoading) {
      return <div className="skeleton-blank slim" />;
    }

    if (outlet.state === undefined) {
      return "-";
    }

    return (
      <span
        style={{
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <span
          style={{
            color:
              outlet.state === "ON"
                ? "forestgreen"
                : outlet.state === "OFF"
                ? "maroon"
                : "",
            fontWeight: "600",
            display: "flex",
          }}
        >
          {(outlet.state || "").toUpperCase()}
        </span>
        <span
          style={{
            color:
              outlet.rebootStatus === "pendingOff"
                ? "maroon"
                : outlet.rebootStatus === "pendingOn"
                ? "forestgreen"
                : "",
          }}
        >
          {outlet.rebootStatus === "pendingOn"
            ? "(Pending On)"
            : outlet.rebootStatus === "pendingOff"
            ? "(Pending Off)"
            : ""}
        </span>
      </span>
    );
  };

  renderCurrentRms = ({ outlet, isLoading, maxOutletReceptacle }) => {
    if (isLoading) {
      return <div className="skeleton-blank slim" />;
    }

    if (outlet.currentRms !== undefined && outlet.currentRms !== null) {
      return (
        <span style={{ display: "flex" }}>
          <span
            style={{
              width: "max-content",
              alignItems: "center",
              display: "flex",
              paddingRight: "5px",
              paddingLeft: "5px",
              color:
                outlet.state !== "ON"
                  ? `#875b5b`
                  : `${getColor(outlet.currentRms / maxOutletReceptacle)}`,
            }}
          >
            <DataValue value={outlet.currentRms} unit="A" />
            <span style={{ padding: "0px 3px" }}>/</span>
            <DataValue value={maxOutletReceptacle} unit="A Max" />
          </span>
        </span>
      );
    }

    return "-";
  };

  renderPower = ({ outlet, isLoading }) => {
    if (typeof outlet.power !== "number") {
      return "-";
    }

    if (isLoading) {
      return <div className="skeleton-blank slim" />;
    }

    return <DataValue value={outlet.power || 0} unit="VA" />;
  };

  renderVoltage = ({ outlet, isLoading }) => {
    if (typeof outlet.circuitVoltage !== "number") {
      return "-";
    }

    if (isLoading) {
      return <div className="skeleton-blank slim" />;
    }

    return <DataValue value={outlet.circuitVoltage || 0} unit="V" />;
  };

  getOperationConfigs = ({ outlet, updateOutlet, darkMode }) => {
    const configs = [];

    if (outlet.state === "OFF") {
      configs.push({
        key: "turn-on",
        label: "Turn On",
        mobileLabel: "Turn On",
        icon: "offline_bolt",
        iconColor: "forestgreen",
        backgroundColor: darkMode ? "#2e4a2e" : "rgb(194 223 194)",
        textColor: darkMode ? "#f3f3f3" : undefined,
        style: { padding: "3px 5px" },
        onClick: () =>
          this.confirmOutletAction({
            outlet,
            nextState: "ON",
            actionLabel: "Turn On",
            updateOutlet,
          }),
        title: "Switch Outlet from OFF state to ON state",
      });
    }

    if (outlet.state === "ON") {
      configs.push({
        key: "turn-off",
        label: "Turn Off",
        mobileLabel: "Turn Off",
        icon: "pause_circle",
        iconColor: "maroon",
        backgroundColor: darkMode ? "#4a2e2e" : "rgb(235 210 210)",
        textColor: darkMode ? "#f3f3f3" : undefined,
        style: { padding: "3px 5px" },
        onClick: () =>
          this.confirmOutletAction({
            outlet,
            nextState: "OFF",
            actionLabel: "Turn Off",
            updateOutlet,
          }),
        title: "Switch Outlet from ON state to OFF state",
      });
    }

    if (outlet.state) {
      configs.push({
        key: "cycle",
        label: "Cycle",
        mobileLabel: "Cycle",
        icon: "replay",
        iconColor: "#1f2933",
        backgroundColor: darkMode ? "#e2e8f0" : "#d9e2ec",
        textColor: "#1f2933",
        style: {
          paddingLeft: "5px",
          paddingTop: "3px",
          paddingBottom: "3px",
          paddingRight: "0px",
        },
        onClick: () =>
          this.confirmOutletAction({
            outlet,
            nextState: "REBOOT",
            actionLabel: "Cycle",
            updateOutlet,
          }),
        title: "Reboot Outlet with outlet configured reboot time",
      });
    }

    return configs;
  };

  render() {
    const { item: outlet } = this.props;
    const isLoading = this.props.parentProps.loadingOutlets.includes(
      outlet.outlet_id
    );

    const {
      updateOutlet,
      outletsSwitchesAllowed,
      noOutletsWithPowerMeasurements,
      editOutletName,
      getOutletItemAndData,
    } = this.props.parentProps;

    const maxOutletReceptacle =
      {
        "IEC 60309 C13R": 12,
        "IEC 60309 C19R": 16,
        "NEMA 5-20R": 16,
      }[outlet.receptacle] || 16;

    const darkMode =
      typeof this.props.parentProps.dark === "boolean"
        ? this.props.parentProps.dark
        : typeof document !== "undefined" &&
          document.body.classList.contains("dark-mode");

    const connectionEstablished = outlet.connectionState === "Connected";
    const outletDetailLink = `/devices/connected/${outlet.enclosureSerialNumber}/outlets/${outlet.outlet_id}`;
    const deviceLink = `/devices/connected/${outlet.enclosureSerialNumber}`;

    const stateContent = this.renderStateContent({ outlet, isLoading });
    const currentRmsContent = this.renderCurrentRms({
      outlet,
      isLoading,
      maxOutletReceptacle,
    });
    const powerContent = this.renderPower({ outlet, isLoading });
    const voltageContent = this.renderVoltage({ outlet, isLoading });

    const operationConfigs = outletsSwitchesAllowed
      ? this.getOperationConfigs({ outlet, updateOutlet, darkMode })
      : [];

    const handleRefresh = () => {
      getOutletItemAndData(outlet.outlet_id);
    };

    const handleEdit = () => {
      editOutletName(outlet);
    };

    const metadataFields = [
      {
        key: "pdu",
        label: "PDU",
        value: (
          <Link to={deviceLink}>
            {outlet.deviceName === "SynLink PDU"
              ? `SynLink PDU (${outlet.enclosureSerialNumber})`
              : outlet.deviceName}
          </Link>
        ),
      },
      {
        key: "state",
        label: "State",
        value: stateContent,
        valueClassName: "outlet-card__value--status",
      },
    ];

    const metricFields = noOutletsWithPowerMeasurements
      ? []
      : [
          {
            key: "current",
            label: "Current RMS",
            value: currentRmsContent,
          },
          {
            key: "power",
            label: "Power",
            value: powerContent,
          },
          {
            key: "voltage",
            label: "Voltage",
            value: voltageContent,
          },
        ];

    const operationsContent =
      outletsSwitchesAllowed && operationConfigs.length > 0 ? (
        <div className="outlet-card__operations">
          {operationConfigs.map((config) => (
            <button
              key={`${outlet.outlet_id}-${config.key}-mobile`}
              type="button"
              className="outlet-card__operation-button"
              style={{
                backgroundColor: config.backgroundColor,
                color: config.textColor || "inherit",
              }}
              onClick={config.onClick}
              title={config.title}
            >
              <i
                className="material-icons"
                aria-hidden="true"
                style={{ color: config.iconColor }}
              >
                {config.icon}
              </i>
              <span>{config.mobileLabel || config.label}</span>
            </button>
          ))}
        </div>
      ) : null;

    return (
      <>
        <div
          key={`${outlet.outlet_id}-table`}
          className={`grid-row-wrapper hide-for-small-only ${
            connectionEstablished ? "" : "disconnected"
          }`}
          title={connectionEstablished ? "" : "Disconnected"}
        >
          <div
            className={`grid-row ${
              connectionEstablished ? "connected" : "disconnected"
            }`}
            style={{ marginBottom: "4px" }}
          >
            <div style={{ flex: columnWidths[1] }}>
              <Link to={outletDetailLink}>{outlet.pduLabeledOutletNum}</Link>
            </div>
            <div style={{ flex: columnWidths[2] }}>
              <Link to={outletDetailLink}>
                <span style={{ textDecoration: "underline" }}>
                  {outlet.outletName}
                </span>
              </Link>
              <NameSyncStatus resource={outlet} />
              <span
                className="hover-show"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "8px",
                }}
                onClick={handleEdit}
              >
                <span className="hover-item">
                  <i className="material-icons">edit</i>
                </span>
              </span>
            </div>
            <div style={{ flex: columnWidths[3] }}>
              <Link to={deviceLink}>
                {outlet.deviceName === "SynLink PDU"
                  ? `SynLink PDU (${outlet.enclosureSerialNumber})`
                  : outlet.deviceName}
              </Link>
            </div>
            <div style={{ flex: columnWidths[4] }}>{stateContent}</div>
            {!noOutletsWithPowerMeasurements && (
              <>
                <div
                  style={{ flex: columnWidths[5] }}
                  title={`${outlet.receptacle} Receptacle`}
                >
                  {currentRmsContent}
                </div>
                <div style={{ flex: columnWidths[6] }}>{powerContent}</div>
                <div style={{ flex: columnWidths[7] }}>{voltageContent}</div>
              </>
            )}
            {outletsSwitchesAllowed && (
              <div
                style={{
                  flex: columnWidths[8],
                  display: "flex",
                  flexWrap: "nowrap",
                  gap: "6px",
                  alignItems: 'center'
                }}
              >
                {operationConfigs.map((config) => (
                  <div
                    key={`${outlet.outlet_id}-${config.key}-desktop`}
                    className="spreadsheet-badge"
                    style={{
                      marginRight: "3px",
                      cursor: "pointer",
                      ...config.style,
                      backgroundColor: config.backgroundColor,
                      color: config.textColor,
                    }}
                    onClick={config.onClick}
                    title={config.title}
                  >
                    <i
                      className="material-icons"
                      style={{
                        marginRight: "0px",
                        color: config.iconColor,
                      }}
                    >
                      {config.icon}
                    </i>
                    <b
                      className="show-for-largexx"
                      style={{ minWidth: "50px" }}
                    >
                      {config.label}
                    </b>
                  </div>
                ))}
              </div>
            )}
            <div style={{ flex: columnWidths[10] }}>
              <span
                title="Refresh PDU Information"
                className="black"
                style={{ cursor: "pointer" }}
                onClick={handleRefresh}
              >
                <i
                  style={{ fontWeight: "600", color: "#6c6f72" }}
                  className="material-icons"
                >
                  sync
                </i>
              </span>
            </div>
          </div>
        </div>
        <OutletCard
          key={`${outlet.outlet_id}-card`}
          detailLink={outletDetailLink}
          outletNumber={outlet.pduLabeledOutletNum}
          outletName={outlet.outletName}
          nameSyncResource={outlet}
          connectionEstablished={connectionEstablished}
          onRefresh={handleRefresh}
          onRefreshLabel="Refresh PDU Information"
          onRename={handleEdit}
          metadata={metadataFields}
          metrics={metricFields}
          footerContent={operationsContent}
        />
      </>
    );
  }
}
const Loading = ({ size, black, fixed }) => (
  <div
    id={fixed ? "wrapper-fixed" : "wrapper"}
    style={{ padding: "3px", marginRight: "3px" }}
  >
    <div className="profile-main-loader" style={{ padding: "0px" }}>
      <div
        className="loader"
        style={{
          width: size || "20px",
          height: size || "20px",
          padding: "0px",
        }}
      >
        <svg className="circular-loader" viewBox="25 25 50 50">
          <circle
            className={black ? "loader-path-black" : "loader-path"}
            cx="50"
            cy="50"
            r="20"
            fill="none"
            strokeWidth="2"
          />
        </svg>
      </div>
    </div>
  </div>
);

class EditOutletForm extends React.Component {
  state = {
    outletName: "",
    loading: false,
  };
  componentDidMount() {
    this.setState({
      outletName: this.props.outlet.outletName,
    });
  }
  render() {
    const { outlet, close } = this.props;

    return (
      <div>
        <TextInput
          label="Outlet Name"
          value={this.state.outletName}
          callback={(txt) => {
            this.setState({ outletName: txt });
          }}
          placeholder="Enter Outlet Name"
        />
        <button
          className="button"
          onClick={() => {
            this.setState({ loading: true });
            this.props.updateOutlet(
              outlet.outlet_id,
              { outletName: this.state.outletName },
              (err, res) => {
                this.setState({ loading: false });
                if (err) {
                  NotificationManager.alert(
                    "Error updating outlet name",
                    "Error"
                  );
                  console.log(err);
                } else {
                  NotificationManager.success(
                    res?.nameSyncStatus === "pending"
                      ? "Outlet name saved. Pending sync."
                      : "Outlet name updated successfully",
                    "Success"
                  );
                  close();
                }
              }
            );
            // this.props.modifyResource(
            //   "outlets",
            //   outlet.outlet_id,
            //   {
            //     outletName: this.state.outletName,
            //   },
            //   (err, res) => {
            //     this.setState({ loading: false });
            //     if (err) {
            //       console.log(err);
            //     } else {
            //       close();
            //     }
            //   },
            //   "outlet_id"
            // );
          }}
        >
          {this.state.loading ? <Loading /> : "Change"}
        </button>
      </div>
    );
  }
}




class PaginatedList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPageNumber: 1,       // which page we’re on (1-based)
      pageSize: 10,
      // pageLoading: {},           // object keyed by page for loading state
    };
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.resetKey !== prevProps.resetKey) {
      this.setState({ currentPageNumber: 1 });
    }
  }

  findPageInCache = (pageNumber) => {
    const { pages } = this.props;
    if (!Array.isArray(pages)) return null;
    return pages.find((p) => p.page === pageNumber);
  };

  handlePageClick = ({ selected }) => {
    const newPage = selected + 1; // react-paginate is 0-based
    this.setState({ currentPageNumber: newPage }, () => {
      this.fetchPageIfNeeded(newPage);
      this.fetchPageIfNeeded(newPage + 1);
      // this.fetchPageIfNeeded(newPage + 2);
    });
  };

  // fetchPageIfNeeded checks if we have a cached page or if we’re already loading it 
  // before calling fetchPage
  fetchPageIfNeeded = (pageNumber) => {
    const hasPageCache = this.findPageInCache(pageNumber);
    if (hasPageCache) {
      // We already have data, do nothing
      return;
    }
    // const isLoading = this.state.pageLoading[pageNumber];
    const isLoading = this.props.pageLoading[pageNumber];
    if (isLoading) {
      console.log(`Already fetching page ${pageNumber}, skipping.`);
      return;
    }
    this.fetchPage(pageNumber);
  };

  fetchPage = (pageNumber) => {
    const { fetchResourcePaginate, resourceName, queryParams={} } = this.props;
    const { search, pageSize } = this.state;

    fetchResourcePaginate(
      resourceName,
      undefined,
      {
        page: pageNumber,
        limit: pageSize,
        ...queryParams
        // search: search,
      }
    );
  };

  getCurrentPageDevices = () => {
    const currentPageObj = this.findPageInCache(this.state.currentPageNumber);
    return currentPageObj ? currentPageObj[this.props.resourceName] : [];
  };

  render() {
    const {
      totalItemCount,
      ItemRenderer,
      pageLoading,
      LoadingProp,
      queryParams,
      showSummary,
      itemLabel,
      renderHeader,
    } = this.props;
    const { currentPageNumber, pageSize } = this.state;
    // total pages
    const totalPages = totalItemCount
      ? Math.ceil(totalItemCount / pageSize)
      : 1;

    // get the devices for the current page
    const currentPageDevices = this.getCurrentPageDevices();
    // see if the current page is loading
    const currentPageIsLoading = !!pageLoading[currentPageNumber];

    // If current page is loading and we have no cached data for that page, show spinner
    const showSpinner = currentPageIsLoading && currentPageDevices.length === 0;
    const hasTotalCount = typeof totalItemCount === "number";
    const resourceLabel = itemLabel || this.props.resourceName || "items";
    let summaryText = null;

    if (showSummary && hasTotalCount && !showSpinner) {
      if (totalItemCount === 0) {
        summaryText = `Showing 0 of 0 ${resourceLabel}`;
      } else {
        const showingStart = (currentPageNumber - 1) * pageSize + 1;
        const showingEnd = Math.min(
          showingStart + currentPageDevices.length - 1,
          totalItemCount
        );

        if (currentPageDevices.length === 0) {
          summaryText = `Showing 0 of ${totalItemCount} ${resourceLabel}`;
        } else {
          summaryText = `Showing ${showingStart}-${showingEnd} of ${totalItemCount} ${resourceLabel}`;
        }
      }
    }
    const summaryContent = summaryText ? (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          color: "#6b7280",
          fontSize: "14px",
          marginBottom: "8px",
        }}
      >
        {summaryText}
      </div>
    ) : null;

    const headerContent = typeof renderHeader === "function" ? renderHeader() : null;

    return (
      <div>
        {summaryContent}
        {headerContent}

        {/* if this page is loading and no data is cached, show spinner */}
        {showSpinner && (
          LoadingProp ? (
            <LoadingProp />
          ) : (
            <div style={{ margin: "16rem 0" }}>
              <Loading black />
            </div>
          )
        )}

        {/* otherwise render the items if we have them (or partial data) */}
        {!showSpinner &&
          currentPageDevices.map((item, i) => (
            <ItemRenderer
              key={item.outlet_id}
              item={item}
              i={i}
              parentProps={this.props.parentProps}
            />
          ))}

        {/* only show pagination if we have more than 1 page */}
        {totalPages > 1 && (
          <div style={{ marginTop: "2rem" }}>
            <ReactPaginate
              previousLabel="Previous"
              nextLabel="Next"
              breakLabel="..."
              forcePage={currentPageNumber - 1}
              pageCount={totalPages}
              onPageChange={this.handlePageClick}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              containerClassName="react-paginate"
              activeClassName="selected"
            />
          </div>
        )}
      </div>
    );
  }
}



export default DeviceOutlets
